<template>
  <Multiselect
               :class="[small ? 'multiselect-sm' : '']"
               v-model="vModel"
               :options="items"
               :custom-label="(opt) => `${opt.name}`"
               track-by="id"
               select-label="Select"
               :placeholder="helper.trans('labels.devices')"
               open-direction="bottom"
               :multiple="multiple"
               :searchable="true"
               :loading="isLoading"
               :internal-search="false"
               :clear-on-select="!multiple"
               :close-on-select="!multiple"
               :options-limit="100"
               :limit="1000"
               :show-no-results="false"
               :hide-selected="multiple"
               @search-change="search"
  >
  </Multiselect>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType, watch} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import APIClient from "@/service/APIClient";
import PaginationDTO from "@/models/PaginationDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";

const api = new APIClient()

export default defineComponent({
  name: "DevicesMultiselect",
  emits: ['update:modelValue'],
  components: {
    Multiselect
  },
  props: {
    small: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    multiple: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    traderIds: Array as Prop<Array<number>>,
    modelValue: {
      type: Array as PropType<any>,
      default: null
    } as Prop<any>
  },
  setup(props, {emit}) {

    const state = reactive({
      isLoading: false as boolean,
      items: [] as TraderDeviceDTO[]
    })

    const search = async (query: string) => {
      state.isLoading = true
      state.items = (await api.traderDevices({limit: 100, offset: 0} as PaginationDTO, {query: query, traderIds: props.traderIds})).items;
      state.isLoading = false
    }

    const vModel = computed({
      get(): any {
        return props.modelValue
      },
      set(value: any): void {
        emit('update:modelValue', value);
      },
    });

    onMounted(() => {
      search('')
    });

    return {
      ...toRefs(state),
      vModel,
      search,
      helper,
      numberFormatter
    }
  }
})
</script>
